// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-application--is-ltr .long-text[data-v-3060b597]{font-size:12px!important}.logo[data-v-3060b597]{display:inline-block;width:22px;height:22px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
